var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toGlitch",style:(_vm.width ? 'width: ' + _vm.width : ''),attrs:{"dark":"","disabled":_vm.disabled,"size":"xl"},on:{"click":function($event){return _vm.emitMint(_vm.nbMint)}}},[_vm._v(" "+_vm._s(_vm.labelBtn)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }